<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'mt-4 ' + config!.cssClass: 'mt-4'"
>
  <h5>{{ config?.label }}</h5>
</div>
